import Dexie from 'dexie'

export default {
    databaseName: "dexie-netmet-radios",

    /**
     * This function will attempt to initialize Dexie, open a connection and resolve the db
     * @param db - optional, pass in a db object that will then be opened and initialized
     * @returns {Promise<unknown>}
     */
    initDB(db = null) {
        return new Promise((resolve, reject) => {
            // create a dexie db
            let _db = null
            if (db) {
                _db = db
            } else {
                _db = new Dexie(this.databaseName)
            }

            // initialize it
            if (_db) {
                if (!_db.isOpen()) {
                    // version 2 - this contains the radio table and the key_value table
                    _db.version(2).stores({
                        radios: 'id, geometry, properties, type',
                        key_value: "id, value"
                    })

                    // version 1 - this has just the radios table
                    _db.version(1).stores({
                        radios: 'id, geometry, properties, type'
                    })

                    // open the database
                    _db.open().then(function () {
                        resolve(_db);
                    })
                } else {
                    // db is open, resolve it
                    resolve(_db);
                }
            } else {
                // cannot create a dexie db connection, return null
                resolve(null);
            }
        })
    }
}
